import {Injectable} from '@angular/core';
import {KluhManagerValidator} from '../../validators/kluh-manager-validator';
import {Observable} from 'rxjs';
import {DownloadFile} from '../../models';
import {BaseSearchDao} from '../../base-search-dao';
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {PageEvent} from '@angular/material/paginator';
import {R2CloudHttpApiService} from '../../r2-cloud-http-api.service';


@Injectable()
export class DownloadFileDaoService extends BaseSearchDao<DownloadFile> implements DataSource<DownloadFile> {
    private dict = {};
    private subject = new BehaviorSubject<DownloadFile[]>([]);
    private totalSubject = new BehaviorSubject<number>(0);

    constructor(http: R2CloudHttpApiService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'download-file');
    }

    filter(params?: any): Observable<DownloadFile[]> {
        return this.http.get<DownloadFile[]>(this.url + '/filter', params);
    }

    downloadById(id: number): Observable<Blob> {
        return this.http.get(this.url + '/download/' + id, null, 'blob');
    }

    getMyFiles(): Observable<DownloadFile[]> {
        return this.http.get<DownloadFile[]>(this.url + '/my-docs');
    }

    connect(collectionViewer: CollectionViewer): Observable<DownloadFile[] | ReadonlyArray<DownloadFile>> {
        this.subject = new BehaviorSubject<DownloadFile[]>([]);
        return this.subject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.subject.complete();
        this.totalSubject.complete();
        this.subject = null;
        this.totalSubject = null;
    }

    load(page: PageEvent): void {
        if (this.subject && this.totalSubject) {
            this.search({field: undefined, value: undefined, limit: page.pageSize, page: page.pageIndex, fieldOrder: 'id', order: 'desc'}).subscribe(value => {
                this.subject.next(value.content);
                this.totalSubject.next(value.totalElements);
            });
        }
    }

    removeItem(id: number): void {
        const downloadFileList = this.subject.getValue().filter((value, key) => {
            return value.id !== id;
        });
        this.subject.next(downloadFileList);
    }

    get total$(): Observable<number> {
        if (!this.totalSubject) {
            this.totalSubject = new BehaviorSubject<number>(0);
        }
        return this.totalSubject.asObservable();
    }
}
